import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { types } from '../../../store/user/types';
import { types as formTypes } from '../../../store/forms/types';
import { PageTitle, PageLabeledButton } from 'components';
// import { checkLoginStatus } from '../../store/user/actions';

const AlreadyLoggedPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const initiated = useSelector(state => state.forms.initiated);

  useEffect(() => {
    dispatch({ type: types.RESET_USER });
    dispatch({ type: formTypes.RESET_FORM });
    dispatch({ type: formTypes.SET_FORM_INITIATED });
  }, [dispatch]);

  // useEffect(() => {
  //   dispatch(checkLoginStatus());
  // }, [dispatch]);

  const handleHomeRedirect = () => {
    navigate('/'); // static?
  };

  if (!initiated) return null;

  return (
    <div className="alreadylogged-page">
      <PageTitle 
        message="Είστε ήδη σε σύνδεση" 
        pageName="alreadylogged" 
      />
      
      <PageLabeledButton 
        labelMessage="Μεταβείτε στην αρχική σελίδα"
        pageName="home-redirect"
        buttonTitle="Αρχική Σελίδα"
        buttonAction={handleHomeRedirect}
      />
    </div>
  );
};

export default AlreadyLoggedPage;